export const updateObject = (oldObject, updatedObject) => {
  return {
    ...oldObject,
    ...updatedObject
  };
};



// WEBPACK FOOTER //
// ./src/store/utility.js